module.exports = __webpack_public_path__ + "static/media/BariolThin-Italic.78d150fb.woff";